import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import axios from './resources/axios';
import { store } from './redux/store';
import { ThemeProvider } from './contexts/ThemeContext';
import { ResponsiveLayoutProvider } from './contexts/ResponsiveLayoutContext';

import 'moment/locale/uk';
import './i18n';
import './index.scss';

const authInfo = store.getState().auth.info;

if (authInfo) {
  axios.defaults.headers.common['x-access-token'] = authInfo.token;
}

const city = store.getState().admins.currentCity;

if (city) {
  axios.defaults.headers.common['city'] = city;
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <ThemeProvider>
          <ResponsiveLayoutProvider>
            <App />
          </ResponsiveLayoutProvider>
        </ThemeProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
